import {
  TbCloudDataConnection,
  TbBrandNextjs,
  TbDatabase,
  TbDevicesCode,
  TbBugOff,
  TbBrandHtml5,
  TbBrandReactNative,
  TbCurrencyDollar,
} from 'react-icons/tb';

// Nav Menu Data
export const NavMenuLists = [
  {
    id: 'home',
    name: 'home',
  },
  {
    id: 'skills',
    name: 'skills',
  },
  {
    id: 'projects',
    name: 'projects',
  },
  {
    id: 'services',
    name: 'services',
  },
  {
    id: 'testimonial',
    name: 'testimonial',
  },
  {
    id: 'contact',
    name: 'contact',
  },
];
// footer menu items
export const footerMenuData = [
  {
    id: 1,
    name: 'Terms and Condition',
    icon: 'fa-solid fa-code',
  },
  {
    id: 1,
    name: 'Privacy Policy',
    icon: 'fa-solid fa-lock',
  },
  {
    id: 1,
    name: 'Help Center',
    icon: 'fa-solid fa-circle-info',
  },
];

// social Link
export const iconData = [
  {
    id: 1,
    name: 'fa-brands fa-facebook-f ',
    link: 'https://www.facebook.com/shahinmia28/',
  },
  {
    id: 1,
    name: 'fa-solid fa-u',
    link: 'https://www.upwork.com/freelancers/~01c43135ed129c77c1?viewMode=1',
  },
  {
    id: 2,
    name: 'fa-brands fa-github',
    link: 'https://github.com/shahinmia28?tab=repositories',
  },
  {
    id: 3,
    name: 'fa-brands fa-linkedin-in',
    link: 'https://www.linkedin.com/in/shahin-mia-08b5b21ba/',
  },
];

export const skillData = [
  {
    id: 1,
    title: 'HTML + CSS',
    class: 'skill-per html',
    tooltip: '95',
  },
  {
    id: 1,
    title: 'HTML + CSS + JavaScript',
    class: 'skill-per css',
    tooltip: '89',
  },
  {
    id: 1,
    title: 'HTML + Bootstrap + CSS',
    class: 'skill-per bootstrap',
    tooltip: '95',
  },
  {
    id: 1,
    title: 'HTML + Bootstrap + CSS + Sass + JavaScript',
    class: 'skill-per javascript',
    tooltip: '83',
  },
  {
    id: 1,
    title: 'React Js + Sass + Bootstrap',
    class: 'skill-per react',
    tooltip: '85',
  },
  {
    id: 1,
    title: 'Next Js + Styled-components + Bootstrap',
    class: 'skill-per Next',
    tooltip: '88',
  },
  {
    id: 1,
    title: 'Node Js + Express Js + MongoDB + JWT + Cloudinary',
    class: 'skill-per express',
    tooltip: '85',
  },
  {
    id: 1,
    title: 'MERN Stack',
    class: 'skill-per mern',
    tooltip: '90',
  },
];
export const roundSkillData = [
  { percentage: '90', name: 'Frontend Skills' },
  { percentage: '87', name: 'Backend Skills' },
  { percentage: '92', name: 'DataBase Skills' },
];

export const myServiceData = [
  {
    id: '1',
    title: 'MERN Stack Web Development',
    subtitle: '2 Years+ Experience',
    docs: 'Experienced at MERN  stack (MongoDB, Express.js, React, Node.js) and also many more frameworks and libraries. Proficients in eye catching front-end design, functional back-end development, RESTful API development, database management, deployment and version control. Now, I learn more modern technology.',
    icon: <TbDevicesCode />,
    date: '2022-present',
  },
  {
    id: '2',
    title: 'NEXT.JS Website Development',
    subtitle: '1 Year+ Experience',
    docs: ` I'm expert to create dynamic, personalized, scalable and SEO friendly web applications by using Next.js. It's a React framework that provides developers with the necessary building blocks to create web applications. It is used by some of the world's largest companies. Next.js is a full-stack web framework that extends React with Rust-based tooling and optimizations for fast builds.`,
    icon: <TbBrandNextjs />,
    date: '2023-present',
  },
  {
    id: '3',
    title: 'REST API Development',
    subtitle: '2 Years+ Experience',
    docs: `A RESTful API is an application programming interface that conforms to the design principles of the REST, or representational state transfer architectural style. REST APIs provide a flexible, lightweight way to integrate applications and to connect components in microservices architectures. RESTful APIs allow the requesting systems to access and manipulate textual representations of Web resources by using a uniform and predefined set of stateless operations`,
    icon: <TbCloudDataConnection />,
    date: '2022',
  },
  {
    id: '4',
    title: 'Database Management',
    subtitle: '2 Years+ Experience',
    docs: `Proficient in NoSQL, MongoDB, Mongoose, Cloudinary and Firebase, I expert in Database Design and Management, Data structuring, schemas defining, ensure data integrity and security. Automated rollbacks and restarts, logs, and audit activity within a database.`,
    icon: <TbDatabase />,
    date: '2022',
  },
  {
    id: '5',
    title: 'React Js App',
    subtitle: '3 Years+ Experience',
    docs: `Designing a website is a very difficult task. But now I offer my client to create a website at an affordable price and in a short time. I will build a website with React js. This is a popular way to create a website. You can hire me as your web designer, I will try my best to build your website.`,
    icon: <TbBrandReactNative />,
    date: '2021',
  },
  {
    id: '6',
    title: 'Bug Fixing',
    subtitle: '3 Years+ Experience',
    docs: `If you have any Bug in your website, I'm here to fixed it. I have much knowledge in HTML, CSS, Bootstrap, Sass, JavaScript, React.js, Next.js, node.js, express.js, mongoDB database, mongoose, react-style-components and so on frameworks and libraries. I can solve your problem within a short time. `,
    icon: <TbBugOff />,
    date: '2021',
  },
  {
    id: '7',
    title: 'PSD/Figma to HTML',
    subtitle: '4 Years+ Experience',
    docs: `If you have any PSD or Figma file, I can convert it into HTML code with Pixel perfect design for you. There are some way to convert PSD or Figma file to HTML like, using pure HTML and CSS, using Bootstrap library, and also using HTML, CSS and JavaScript. You can choose any method, I will give you the code to deploy`,
    icon: <TbBrandHtml5 />,
    date: '2020',
  },
  {
    id: '8',
    title: 'Payment Gateway',
    subtitle: '1 Year+ Experience',
    docs: `Most of the website needs to get payment from it's user. SSLCommerz Provides the best quality and secure payment gateway. I can connect SSLCommerz with your website to get payment.`,
    icon: <TbCurrencyDollar />,
    date: '2022',
  },
];
export const myProjects = [
  {
    id: '1',
    title: 'rioviz website project',
    img: '../image/img-slider/rioviz.jpeg',
    link: 'https://rioviz.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/website-rioviz.git',
  },

  {
    id: '2',
    title: 'Dr.Change Clinical Website',
    img: '../image/img-slider/dr.change.jpeg',
    link: 'https://drproject1.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/dr.project.git',
  },
  {
    id: '3',
    title: `Nephrologist Doctor's Website`,
    img: '../image/img-slider/nephrology.jpeg',
    link: 'https://nephrology-28.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/nephrology.git',
  },
  {
    id: '4',
    title: 'e-Commerce Website',
    img: '../image/img-slider/ecommerce.jpeg',
    link: 'https://shahinecom.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/ecom.git',
  },
  {
    id: '5',
    title: 'MERN Project for School Website',
    img: '../image/img-slider/madrasha.jpeg',
    link: 'https://madrashabd.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/madrashaDB.git',
  },
  {
    id: '6',
    title: 'Next Js Project',
    img: '../image/img-slider/nextapp.jpeg',
    link: 'https://next1-eiohp1r5s-shahinmia29.vercel.app/',
    sourceCode: 'https://github.com/shahinmia28/next1.git',
  },
  {
    id: '7',
    title: 'Resturent Website',
    img: '../image/img-slider/gofood.jpeg',
    link: 'https://dull-gold-abalone-sari.cyclic.cloud/',
    sourceCode: 'https://github.com/shahinmia28/mern-cyclic.git',
  },
  {
    id: '8',
    title: 'Soccer club upWork project',
    img: '../image/img-slider/soccer.jpeg',
    link: 'https://soccer-club-upwork.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/upwork-project-first.git',
  },
  {
    id: '9',
    title: 'Code. Practice project',
    img: '../image/img-slider/code.jpeg',
    link: 'https://code-projects.netlify.app/',
    sourceCode: 'https://github.com/shahinmia28/code.git',
  },
];
// Testimonial data

export const testimonial = [
  {
    id: 1,
    name: 'Alex Jara',
    title: 'Senior Virtual Assistance',
    img: '../image/tman3.jpg',
    icon: 'assets/twitter.png',
    desc: 'He is friendly. We would highly recommend and we will continue to work with him.',
  },
  {
    id: 2,
    name: 'William Macc',
    title: 'Principal',
    img: '../image/tman2.jpg',
    icon: 'assets/youtube.png',
    desc: 'Thanks for creating my website pixel perfect. I personally recommend you.',
    featured: true,
  },
  {
    id: 3,
    name: 'Don Jow',
    title: 'Business man',
    img: '../image/tman1.jpg',
    icon: 'assets/linkedin.png',
    desc: 'Thanks for your fantastic design. It helps me to grow my business all over the country.',
  },
];
